import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "11.25",
      y: "5",
      width: "1.5",
      height: "14",
      rx: ".75",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("rect", {
      x: "5",
      y: "11.25",
      width: "14",
      height: "1.5",
      rx: ".75",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render };